import {
  AssociatedProperty,
  IAssociatedProperty,
} from '@app/models/AssociatedProperty'
import { List, Record } from 'immutable'
import { FeedItem, IFeedItem } from './FeedItem'

export interface IPropertyLead {
  readonly lead: IFeedItem
  readonly properties: List<IAssociatedProperty>
}

const PropertyLeadRecord = Record({
  lead: undefined,
  properties: List<AssociatedProperty>(),
})

export class PropertyLead extends PropertyLeadRecord implements IPropertyLead {
  public static fromJS(initialState?: any) {
    if (!initialState) {
      return new PropertyLead()
    }

    const { lead, properties, ...rest } = initialState

    return new PropertyLead({
      lead: FeedItem.fromJS(lead),
      properties: properties
        ? List(
            properties.map((a: AssociatedProperty) =>
              AssociatedProperty.fromJS(a),
            ),
          )
        : undefined,
      ...rest,
    })
  }

  public readonly lead: IFeedItem
  public readonly properties: List<AssociatedProperty>

  constructor(props?: Partial<PropertyLead>) {
    props ? super(props) : super()
  }
}
